export { default } from './CoursePicker';



// WEBPACK FOOTER //
// ./src/components/DataCentre/CoursePicker/index.ts